import { __decorate } from "tslib";
import { property } from 'lit/decorators/property.js';
import { configurationContext, consumer } from './context';
export const withConfig = (superClass) => {
    class ConfigurationConsumerElement extends superClass {
    }
    __decorate([
        consumer({ context: configurationContext, subscribe: true }),
        property({ attribute: false })
    ], ConfigurationConsumerElement.prototype, "config", void 0);
    return ConfigurationConsumerElement;
};
//# sourceMappingURL=consumer-mixin.js.map